import React from 'react';
import styled from 'styled-components';
import i18n from 'i18next';
import { useTranslation } from "react-i18next";
import { useNavigate } from 'react-router-dom';
import useViewStore from "../../store/useViewStore";
import { basename } from "../../setting";

function LanguageSwitcher() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { isMobileView } = useViewStore((state) => state);
  /** 切换语言 */
  const handleChangeLanguage = () => {
    let lang;
    const curWwwPath = window.location.href;
    if (curWwwPath.match(/\/ch\b|\/ch\//gi)) {
      lang = "ch";
    } else if (curWwwPath.match(/\/en\b|\/en\//gi)) {
      lang = "en";
    } 
    // 构建新的 URL
    const newPath = `/${basename}/${lang === "ch" ? 'en' : 'ch'}`;
    // 重定向到新的 URL
    window.location.href=window.origin+ newPath;
  };
  
  return (
    <Switcher $isMobileView={isMobileView} onClick={() => {
      // const pathname = window.location.pathname.replace(`/${i18n.language}`, i18n.language === "ch" ? "/en" : "/ch");
      // navigate(pathname, { replace: true });
      // i18n.changeLanguage(i18n.language === "ch" ? "en" : "ch");
      handleChangeLanguage()
    }}>
      <LangImg src={`${process.env.PUBLIC_URL}/images/earth.svg`} alt="language switcher" />
      {
        !isMobileView && <Lang>{t("lang")}</Lang>
      }
    </Switcher>
  );
}

const Switcher = styled.button`
  background: none;
  border: none;
  border-radius: 10px;
  color: var(--aia-bx-dark-blue);
  font-weight: bold;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  gap: 5px;
  align-items: center;
  
  ${props => props.$isMobileView ? `padding: 15px;` : `padding: 6px;`}

  &:hover {
    background-color: var(--aia-bx-bright-blue-5);
  }
`;

const LangImg = styled.img`
  width: 24px;
  height: 24px;
`

const Lang = styled.div`
  font-size: 14px;
  font-weight: bold;
  width: 30px;
`;

export default LanguageSwitcher;